import React, { Component } from 'react';
import { connect } from "react-redux";
import {SPOTLIGHT} from 'constants/user-view-modes.js';

class AddTracksButton extends Component {
    render() {
        let text = this.props.viewMode === SPOTLIGHT ?
            'ADD TRACKS TO SPOTLIGHT' :
            'ADD TRACKS TO MIX';
        if (this.props.isEditing && this.props.userLoaded) {
            return (
                <div onClick={() => this.props.onClickAddTrack()} className='add-spotlight-track'>
                  {text}
                </div>);
        } else {
            console.log('did not show the add tracks button because isEditing = ' + this.props.isEditing + ' and userLoaded=' + this.props.userLoaded);
            return (<div></div>);
        }
    }
}

export default AddTracksButton;
